import React from 'react'
import { ChanceText, Description, Layout } from './styles'
import { transformDate } from '~/utils'

interface ProbabilityChangeProps {
  year: string
  probability: number
}

export const ProbabilityChange = ({ year, probability }: ProbabilityChangeProps): JSX.Element => (
  <Layout>
    <Description>
      Probabilidade de alteração{`\n`}
      <strong>{transformDate({ date: year, dateFormat: 'yyyy' })}</strong>
    </Description>
    <ChanceText>{probability}%</ChanceText>
  </Layout>
)
